import React from 'react';
import { PrimaryButton } from '../BasicForm';

export const SecondaryFormNav = (props) => (
	<div className="form-navigation-2">
		<PrimaryButton
			className="primary-button" 
	        label={props.primaryLabel} 
	        handleClick={props.handlePrimaryClick} 
	        options={props.primaryOptions} />
		<PrimaryButton
			className="link-style"
			label={props.secondaryLabel}
	        handleClick={props.handleSecondaryClick} 
	        options={props.secondaryOptions} />			
	</div>
);


// WEBPACK FOOTER //
// ./src/components/SecondaryFormNav/SecondaryFormNav.js